"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWafHeaders = exports.isWafConfigured = void 0;
const log_1 = require("../log");
const log = (0, log_1.getLog)(module);
/**
 * Gets headers for use with the WAF.
 */
function getWafHeaders() {
    // only add these headers on the server
    const wafHeaders = {};
    if (typeof window === 'undefined') {
        // set headers for WAF if they are configured
        const wafHeaderName = process.env.WAF_HEADER;
        const wafKey = process.env.WAF_KEY;
        if (wafHeaderName && wafKey) {
            log.trace('Setting WAF key header name to %s and value to %s', wafHeaderName, wafKey);
            Object.assign(wafHeaders, { [wafHeaderName]: wafKey });
        }
        const proxyAllowForwardedHeaderName = process.env.PROXY_ALLOW_FORWARDED_HEADER_NAME;
        const proxyAllowForwardedHeaderKey = process.env.PROXY_ALLOW_FORWARDED_HEADER_KEY;
        if (proxyAllowForwardedHeaderName && proxyAllowForwardedHeaderKey) {
            log.trace('Setting proxy allow forwarded header name to %s and value to %s', proxyAllowForwardedHeaderName, proxyAllowForwardedHeaderKey);
            Object.assign(wafHeaders, { [proxyAllowForwardedHeaderName]: proxyAllowForwardedHeaderKey });
        }
        const forwardedIpHeaderName = process.env.FORWARDED_IP_HEADER_NAME;
        const ipAddress = global.auroraIpAddress;
        if (forwardedIpHeaderName && ipAddress) {
            log.trace('Setting forwarded ip header name to %s and forwarded ip to %s', forwardedIpHeaderName, ipAddress);
            Object.assign(wafHeaders, { [forwardedIpHeaderName]: ipAddress });
        }
    }
    return wafHeaders;
}
exports.getWafHeaders = getWafHeaders;
/**
 * Is this site configured to use the WAF
 */
function isWafConfigured() {
    const wafHeader = process.env.WAF_HEADER;
    const wafKey = process.env.WAF_KEY;
    return !!(wafHeader && wafKey);
}
exports.isWafConfigured = isWafConfigured;
//# sourceMappingURL=WafHeaderHelper.js.map